import React from 'react';
import { LegendDataItem } from './portfolioReturnsLegendsData';
import './PortfolioReturnsLegends.scss';
import classnames from 'classnames';
import PortfolioReturnsLegend from './PortfolioReturnsLegend';

interface PortfolioReturnsIndexLegendsProps {
    index1Config?: string;
    index2Config?: string;
    index1Value?: LegendDataItem;
    index2Value?: LegendDataItem;
}

export default function PortfolioReturnsIndexLegends(
    props: PortfolioReturnsIndexLegendsProps
) {
    const { index1Config, index2Config, index1Value, index2Value } = props;

    return (
        <div className={classnames('PortfolioReturnIndexesLegends')}>
            {index1Config && (
                <PortfolioReturnsLegend
                    alignDropdown={'right'}
                    hideSeriesPropertyName={'hideIndex1'}
                    className={'index'}
                    label={index1Config}
                    value={index1Value}
                    hideValueChange={true}
                />
            )}
            {index2Config && (
                <PortfolioReturnsLegend
                    alignDropdown={'right'}
                    hideSeriesPropertyName={'hideIndex2'}
                    className={'index'}
                    label={index2Config}
                    value={index2Value}
                    hideValueChange={true}
                />
            )}
        </div>
    );
}
